module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/icoGroupGreen-399972a35bde4fbce3ae44f30e9b7e09.svg";